import React, { useState, useEffect } from 'react';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';
import { deleteExternalJobBoard, getDeleteExternalJobBoardPreview } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const CONFIRMATION_TEXT = 'I understand, delete';

const DeleteExternalJobBoardForm = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { onResponse, onError, closeDeleteExternalJobBoardModal } = useExternalJobBoardsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const [confirmationInput, setConfirmationInput] = useState('');

  const boardId = externalJobBoardsState?.deleteExternalJobBoard?.externalJobBoardId;
  const previewLoaded = externalJobBoardsState?.jobDescriptionCount != null;

  useEffect(() => {
    if (boardId) {
      getDeleteExternalJobBoardPreview({
        externalJobBoardId: boardId,
        onResponse,
        onError,
      });
    }
  }, [boardId]);

  const handleSubmit = () => {
    if (confirmationInput !== CONFIRMATION_TEXT) return;
    deleteExternalJobBoard({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteExternalJobBoard: externalJobBoardsState?.deleteExternalJobBoard,
      },
    });
  };

  const isConfirmed = confirmationInput === CONFIRMATION_TEXT;

  return (
    <Form onSubmit={handleSubmit}>
      {previewLoaded ? (
        <FormInstruction>
          Deleting <strong>{externalJobBoardsState.url}</strong> will permanently destroy:
          <ul>
            <li>{externalJobBoardsState.jobDescriptionCount} job description{externalJobBoardsState.jobDescriptionCount !== 1 ? 's' : ''}</li>
            <li>{externalJobBoardsState.matchScoreCount} match score{externalJobBoardsState.matchScoreCount !== 1 ? 's' : ''}</li>
            <li>{externalJobBoardsState.jobProspectCount} job prospect{externalJobBoardsState.jobProspectCount !== 1 ? 's' : ''}</li>
          </ul>
          Consider using <strong>Archive</strong> instead if this board was once legitimate and has good historical data.
          This action cannot be undone.
        </FormInstruction>
      ) : (
        <FormInstruction>Loading deletion preview...</FormInstruction>
      )}

      <Field label={`Type "${CONFIRMATION_TEXT}" to confirm`}>
        <Input
          type="text"
          value={confirmationInput}
          onChange={(e) => setConfirmationInput(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeDeleteExternalJobBoardModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
            disabled={!isConfirmed}
          >
            Delete External Job Board
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteExternalJobBoardForm;
